export const TOOLBAR_HEIGHT_PX = 32;

const BORDER_WEIGHT_PX = 1;

export const TOOLBAR_ITEM_HEIGHT_PX = TOOLBAR_HEIGHT_PX - BORDER_WEIGHT_PX * 2;
